import { AlertTriangle } from 'lucide-react';

/**
 * Marca de tela fiscal com números de exemplo: tela fiscal não mostra número de exemplo sem a marca
 * "demonstração" (fila de sustentação da Reforma TurboSPED, T241, item 3).
 */
export function AvisoDemonstracao({ detalhe }: { detalhe: string }) {
  return (
    <div
      role="note"
      className="flex items-start gap-3 rounded-lg border border-amber-300 bg-amber-50 px-4 py-3 text-amber-900"
    >
      <AlertTriangle className="h-5 w-5 mt-0.5 shrink-0" />
      <div className="space-y-0.5">
        <p className="font-semibold">Demonstração</p>
        <p className="text-sm">{detalhe}</p>
      </div>
    </div>
  );
}
